import { useRoutes } from 'react-router-dom';

import ADMIN_DASHBOARD from './AppRoutes/admin/dashboard';
import AUTHENTICATION from './AppRoutes/authentication';
import CHECK_IN from './AppRoutes/checkin';
import INSTANT from './AppRoutes/instant';
import KIOSK from './AppRoutes/kiosk';
import PATIENT_DASHBOARD from './AppRoutes/patient/dashboard';
import PRACTICE_DASHBOARD from './AppRoutes/practice/dashboard';
import PUBLIC from './AppRoutes/public';
import SELF_SCHEDULING from './AppRoutes/self-scheduling';
import USER_ACTIVATION from './AppRoutes/user-activation';

export const APP_ROUTES = [
  ...PUBLIC,
  ...PRACTICE_DASHBOARD,
  ...ADMIN_DASHBOARD,
  ...PATIENT_DASHBOARD,
  ...CHECK_IN,
  ...INSTANT,
  ...AUTHENTICATION,
  ...USER_ACTIVATION,
  ...SELF_SCHEDULING,
  ...KIOSK
];

export const Routes = () => useRoutes(APP_ROUTES);
